import { Map } from 'immutable';
import { types as jobTypes } from '@saucelabs/sl-module-jobs';

import { types as jobContainerTypes } from './../job';
import * as actions from './actions';
import * as constants from './constants';
import * as types from './types';

const initialState = new Map({
  files: new Map(),
  status: constants.STATUS.LOADING,
  selectedFilename: '',
});

const fileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SHOW_LOADER:
      return state.set('status', constants.STATUS.LOADING);
    case jobTypes.ASSET_GET.FAILURE:
    case jobContainerTypes.ASSETS_EXPIRED:
      return state.set('status', constants.STATUS.FAILURE);
    case types.ATTACH_FILE: {
      const files = state.get('files');
      const linesCount = actions.countLines(payload.data);
      const updatedFiles = files.set(
        payload.name,
        { data: payload.data, lines: linesCount },
      );
      return state.withMutations((mutable) => {
        mutable.set('files', updatedFiles);
        mutable.set('status', constants.STATUS.SUCCESS);
      });
    }
    case types.SELECT_FILE:
      return state.set('selectedFilename', payload);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default fileReducer;
